import { supabase } from '../lib/supabase/client';
import { User, AuthError } from '@supabase/supabase-js';

interface SignUpData {
  email: string;
  password: string;
  fullName: string;
  companyName?: string;
  phone?: string;
}

export const authService = {
  async signUp(data: SignUpData): Promise<{ user: User | null; error: AuthError | null }> {
    const { data: authData, error } = await supabase.auth.signUp({
      email: data.email,
      password: data.password,
      options: {
        data: {
          full_name: data.fullName,
          company_name: data.companyName || '',
          phone: data.phone || '',
          role: 'customer'
        }
      }
    });

    return { user: authData?.user || null, error };
  },

  async signIn(email: string, password: string): Promise<{ user: User | null; error: AuthError | null }> {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    return { user: data?.user || null, error };
  },

  async signOut(): Promise<{ error: AuthError | null }> {
    const { error } = await supabase.auth.signOut();
    return { error };
  },

  async getSession() {
    const { data: { session } } = await supabase.auth.getSession();
    return session;
  },

  async getUser() {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  }
};